import { fetchFeatureFlags } from "utils/featureFlags/fetchFeatureFlags";
import { isAgisMembershipMode } from "utils/isAgisMembershipMode";

const REACT_APP_AUTH_URL = process.env.REACT_APP_AUTH_URL;
const REACT_APP_AUTH_AGIS_URL = process.env.REACT_APP_AUTH_AGIS_URL;

export const getLoginPrefixUrl = async () => {
  if (window?.CWRR?.SSOHost) return window?.CWRR?.SSOHost;
  try {
    const flags = await fetchFeatureFlags();
    const isAgisMembership = isAgisMembershipMode(flags);
    const prefixUrl = isAgisMembership ? REACT_APP_AUTH_AGIS_URL : REACT_APP_AUTH_URL;

    return prefixUrl;
  } catch (error) {
    throw error;
  };
};
